import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const LOAN_HISTORY_COLLECTION = 'inventoryLoanHistory';

export interface LoanHistoryRecord {
  id: string;
  loanId: string;
  itemId: string;
  ownerId: string;
  borrowerName: string;
  borrowerGuestId?: string;
  borrowerGroup?: string;
  quantity: number;
  loanedAt: string;
  dueDate?: string;
  returnedAt?: string;
  status: 'active' | 'returned';
}

export const getItemLoanHistory = async (
  itemId: string,
  ownerId: string
): Promise<LoanHistoryRecord[]> => {
  if (!itemId || !ownerId) return [];
  const q = query(
    collection(db, LOAN_HISTORY_COLLECTION),
    where('itemId', '==', itemId),
    where('ownerId', '==', ownerId)
  );
  const snapshot = await getDocs(q);
  const records: LoanHistoryRecord[] = [];
  snapshot.forEach((docSnap) => {
    records.push({ id: docSnap.id, ...(docSnap.data() as Omit<LoanHistoryRecord, 'id'>) });
  });
  records.sort((a, b) => new Date(b.loanedAt).getTime() - new Date(a.loanedAt).getTime());
  return records;
};
